import { Box, Stack, Typography } from "@mui/material";
import bidit from "../../../asset/images/cell_phone_3.png";
import sto from "../../../asset/images/sto.png";
import sto2 from "../../../asset/images/sto2.png";
import sto3 from "../../../asset/images/sto3.png";

export default function Working({text}){
    console.log(text)
    const items = [
      { label: text.workingFirst, image: sto },
      { label: text.workingSecond, image: sto2 },
      { label: text.workingThird, image: sto3 },
    ];

    return (
      <Box component="section" sx={{ my: { xs: 4, md: 7 } }}>
        <Typography
          component="h2"
          sx={{
            mb: { xs: 3, md: 4 },
            textAlign: "center",
            fontFamily: "Assistant",
            fontWeight: 800,
            fontSize: { xs: "1.75rem", md: "2.35rem" },
            color: "#173c5d",
          }}
        >
          Bidit עובדת בשבילך
        </Typography>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 3, md: 5 }}
          alignItems="center"
        >
          <Box
            sx={{
              width: { xs: "100%", md: "46%" },
              maxWidth: 560,
              p: { xs: 1.5, md: 2 },
              borderRadius: "28px",
              bgcolor: "#fff",
              border: "1px solid #e4edf5",
              boxShadow: "0 18px 42px rgba(19, 72, 116, .10)",
            }}
          >
            <Box
              component="img"
              src={bidit}
              alt="אפליקציית Bidit"
              sx={{ display: "block", width: "100%", height: "auto", borderRadius: "22px" }}
            />
          </Box>

          <Stack spacing={2} sx={{ width: { xs: "100%", md: "54%" } }}>
            {items.map((item) => (
              <Stack
                key={item.label}
                direction="row"
                spacing={2}
                alignItems="center"
                sx={{
                  p: { xs: 2, md: 2.4 },
                  borderRadius: "18px",
                  bgcolor: "#fff",
                  border: "1px solid #e7eef5",
                  boxShadow: "0 8px 24px rgba(25, 68, 105, .07)",
                }}
              >
                <Box
                  sx={{
                    width: { xs: 92, sm: 98, md: 106 },
                    height: { xs: 92, sm: 98, md: 106 },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "22px",
                    overflow: "hidden",
                    background: "linear-gradient(145deg, #f5fbff 0%, #edf6fc 100%)",
                    border: "1px solid #dcebf6",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={item.image}
                    alt=""
                    sx={{ width: "100%", height: "100%", objectFit: "contain", transform: "scale(1.22)", transformOrigin: "center" }}
                  />
                </Box>
                <Typography
                  component="h3"
                  sx={{
                    m: 0,
                    fontFamily: "Assistant",
                    fontWeight: 700,
                    fontSize: { xs: "1.05rem", md: "1.22rem" },
                    lineHeight: 1.45,
                    color: "#274b68",
                  }}
                >
                  {item.label}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </Box>
    );
}
